module.exports = "/_next/static/images/0c7c0ea78c838c19a5e37856e0b667f8-gift-illustration@3x.png.webp";